<template>
  <div class="flex justify-center">
    <div class="board-column">
      <div class="board-column-header">
        <el-button
          type="primary"
          @click="submitSort"
        >
          {{ t(submitButton) }}
        </el-button>
        <el-button @click="resetSort">
          {{ t(resetButton) }}
        </el-button>
      </div>
      <draggable
        class="board-column-content"
        :style="{maxHeight: maxListHeight, overflowY: 'auto'}"
        tag="ul"
        :list="orderList"
        v-bind="{
          animation: 0,
          group: 'description',
          disabled: false,
          ghostClass: 'ghost'
        }"
        @start="isDragging = true"
        @end="isDragging = false"
      >
        <div
          class="board-item"
          v-for="item, index in orderList"
          :key="item[columnStruct.order]"
        >
          {{ index + 1 }}. {{ item[columnStruct.name] }}{{ columnStruct.number && ' | ' + item[columnStruct.number] }}
        </div>
      </draggable>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from 'vue'
import { VueDraggableNext } from 'vue-draggable-next'
import { useI18n } from 'vue-i18n'

type ColumnStructType = {
  id: number
  number: string
  name: string
  order: string
}

export default defineComponent({
  components: {
    draggable: VueDraggableNext
  },
  props: {
    list: {
      type: [] as PropType<Array<any>>,
      default: () => {
        return []
      }
    },
    columnStruct: {
      type: Object as PropType<ColumnStructType>,
      required: true
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    },
    maxListHeight: {
      type: String,
      default: '400px'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const orderList = ref(props.list)
    const submitSort = () => {
      orderList.value.forEach((item, index) => {
        item[props.columnStruct.order] = index + 1
      })
      context.emit('submit')
    }
    const resetSort = () => {
      orderList.value.sort((a, b) => a[props.columnStruct.order] - b[props.columnStruct.order])
      context.emit('reset')
    }
    watch(() => props.list, (list) => {
      orderList.value = list
    })
    return {
      t,
      orderList,
      submitSort,
      resetSort
    }
  }
})

</script>

<style lang="scss" scoped>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.board-column {
  min-width: 300px;
  min-height: 100px;
  height: auto;
  overflow: hidden;
  background: #f0f0f0;
  border-radius: 3px;

  .board-column-header {
    height: 50px;
    line-height: 50px;
    overflow: hidden;
    padding: 0 20px;
    text-align: center;
    color: #fff;
    border-radius: 3px 3px 0 0;
  }

  .board-column-content {
    height: auto;
    overflow: hidden;
    border: 10px solid transparent;
    min-height: 60px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;

    .board-item {
      cursor: pointer;
      width: 100%;
      height: 64px;
      margin: 5px 0;
      background-color: #fff;
      text-align: left;
      line-height: 54px;
      padding: 5px 10px;
      box-sizing: border-box;
      box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
